import React from 'react';
import useLegalVersions from '../../hooks/useLegalVersions';

const Terms = () => {
  const versions = useLegalVersions();
  return (
    <div className="container my-5 legal-document">
      <h1 className="mb-2">Terms of Service</h1>
      <p className="text-muted">Version {versions.terms.version} · Effective {versions.terms.effectiveDate}</p>
      <p>These terms govern access to MyCommunity Services. By creating or using an account, you agree to use the platform lawfully and in accordance with your community's authorized processes.</p>

      <h3>1. Account responsibilities</h3>
      <p>Provide accurate information, protect your credentials and promptly report suspected unauthorized access. You are responsible for activity performed through your account.</p>

      <h3>2. Community administration</h3>
      <p>Community administrators configure services, approve accounts and manage community records. MyCommunity provides the platform and does not independently authorize community decisions, charges, visitor access or resident approvals.</p>

      <h3>3. Acceptable use</h3>
      <p>Do not misuse the platform, access another person's information without authority, upload unlawful or malicious content, disrupt the service, or attempt to bypass security controls.</p>

      <h3>4. Finance records</h3>
      <p>Unless a payment gateway is expressly enabled, MyCommunity records and verifies payment information but does not hold community money. Residents and administrators must verify payment destinations and references.</p>

      <h3>5. Availability and changes</h3>
      <p>We aim to provide a reliable service, but maintenance, infrastructure failures and events outside our control may affect availability. Material changes to these terms will be published with a new version.</p>

      <h3>6. Suspension and termination</h3>
      <p>Accounts may be suspended for security reasons, community deactivation, expiry or violation of these terms. Required finance, audit and security records may remain subject to applicable retention requirements.</p>

      <h3>7. Contact</h3>
      <p>Contact MyCommunity support or your Community Administrator if you have questions about these terms.</p>
    </div>
  );
};

export default Terms;
